interface Props {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: Props) {
  return (
    <div className={`mb-8 md:mb-10 ${align === "center" ? "text-center" : ""}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-1.5 text-xs text-primary-500 font-bold uppercase tracking-widest mb-2.5">
          <span className="w-2 h-2 rounded-full bg-accent-500"></span>
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">{title}</h2>
      {desc && (
        <p className={`mt-3 text-sm md:text-base text-foreground-600 max-w-2xl ${align === "center" ? "mx-auto" : ""}`}>
          {desc}
        </p>
      )}
    </div>
  );
}